import { firebase, storage } from 'core';
import { Api } from 'lib';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { store } from 'store';

const FbLogin = ({ CustomButton, handleLoading, redirectUrl }) => {
  async function login({ id, name, email, picture, status }) {
    if (status === 'unknown') return;

    handleLoading();
    const res = await Api.post(
      '/users/fbLogin',
      { email, id, name, avatar: picture.data.url },
      'navigator'
    );
    handleLoading();
    if (!res) return;

    await storage.setItem('token', res.token);

    firebase.logEvent(res.created ? 'sign_up' : 'login', { method: 'facebook' });

    // Strip leading slash from redirectUrl since User.js adds one
    const navigateTo = redirectUrl
      ? decodeURIComponent(redirectUrl).replace(/^\//, '')
      : res.user.admin || process.env.REACT_APP_DEFAULT_TEAM_REDIRECT === 'false' ? null : `profile/${process.env.REACT_APP_DEFAULT_TEAM_USERNAME || 'fctokyo'}`;

    store.dispatch({
      type: 'SET_USER',
      payload: { ...res.user, navigateTo }
    });

    handleLoading();
  }

  return (
    <FacebookLogin
      appId={459295369556032}
      scope="public_profile, email"
      fields="name,email,picture"
      callback={login}
      render={CustomButton}
    />
  );
};

export default FbLogin;
